export const TOURNAMENTS = 'tournaments';
export const TOURNAMENT = 'tournament';
export const SPLASH = 'splash';

export const views = [TOURNAMENTS, TOURNAMENT, SPLASH];
